<div class="contact-skeleton">
  <div class="contact-skeleton__header">
    <div class="contact-skeleton__header--image"></div>
    <div class="contact-skeleton__header--name">
      <div></div>
      <div></div>
    </div>
  </div>
  @for (row of numberOfRows; track index; let index = $index) {
    <div class="contact-skeleton__row">
      <div class="contact-skeleton__row--icon"></div>
      <div class="contact-skeleton__row--value"></div>
    </div>
  }
</div>
